import { checkIsMobile, getMobileDeviceType } from '#client/utils/devices';

/**
 * Get width of canvas
 * Because of the canvas is not responsive, we need to set width of canvas
 *
 * @returns {number} width of canvas
 *
 */
export const getWidthOfCanvas = () => {
  const deviceType = checkIsMobile() ? getMobileDeviceType() : 'desktop';
  switch (deviceType) {
    case 'mobile':
      return 600;
    case 'tablet':
      return 800;
    default:
      return 1200;
  }
};
